export default {
    methods: {
        addDays(date, days) {
            const dateCopy = new Date(date);
            dateCopy.setDate(date.getDate() + days);
            return dateCopy;
        },
        addHours(date, hours) {
            const dateCopy = new Date(date);
            dateCopy.setTime(date.getTime() + (hours * 60 * 60 * 1000));
            return dateCopy;
        },
        dateFromDateString(dateString) {
            const dateObject = new Date(`${dateString}T00:00`);
            return dateObject;
        },
        elapsedTime(startTime, endTime) {
            var timeDiff = endTime - startTime;

            timeDiff /= 1000;

            var seconds = Math.round(timeDiff % 60);

            timeDiff = Math.floor(timeDiff / 60);

            var minutes = Math.round(timeDiff % 60);
            var minutesStr = minutes.toString().padStart(2, "0");

            timeDiff = Math.floor(timeDiff / 60);

            var hours = Math.round(timeDiff % 24);
            var hoursStr = hours.toString().padStart(2, "0");

            timeDiff = Math.floor(timeDiff / 24);

            var days = timeDiff;

            var elapsedTimeStr = `${days}d ${hoursStr}h ${minutesStr}m`;

            if (elapsedTimeStr < "0d 00h 00m") {
                return "";
            }

            return elapsedTimeStr;
        },
        getDateTimeNow() {
            var dateOffset = 60 * 60 * 1000 * 3; //3 hours
            var myDate = new Date();
            myDate.setTime(myDate.getTime() - dateOffset);
            return myDate;
        },
        getToday() {
            const date = new Date();
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            var monthDisplay = month.toString().padStart(2, '0');
            var dayDisplay = day.toString().padStart(2, '0');
            return `${year}-${monthDisplay}-${dayDisplay}`;
        },
        dateTimeToJsonString(date) {
            let date2 = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
            return date2.toISOString();
            // let dateString = date2.getFullYear() + '-' + date2.getMonth().toString().padStart(2, '0') + '-' + date2.getDate().toString().padStart(2, '0');
            // let hourString = date2.getHours().toString().padStart(2, '0') + ':' + date2.getMinutes().toString().padStart(2, '0') + ':' + date2.getSeconds().toString().padStart(2, '0');
            // return (dateString + 'T' + hourString);
        },
        dateTimeRemoveTZ(date) {
            let date2 = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
            return date2;
        },
        differenceInMinutes(startDate, endDate) {
            let diffInMinutes = this.differenceInSeconds(startDate, endDate) / 60;
            return diffInMinutes;
        },
        differenceInSeconds(startDate, endDate) {
            let diffInMilliseconds = endDate - startDate;
            let diffInSeconds = diffInMilliseconds / 1000;
            return diffInSeconds;
        },
        formatDate(date) {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            var monthDisplay = month.toString().padStart(2, '0');
            var dayDisplay = day.toString().padStart(2, '0');
            return `${year}-${monthDisplay}-${dayDisplay}`;
        },
        formatDatePtBr(date) {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            let monthDisplay = month.toString().padStart(2, '0');
            let dayDisplay = day.toString().padStart(2, '0');
            return `${dayDisplay}/${monthDisplay}/${year}`;
        },
        formatDatetimePtBr(date) {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            let h = date.getHours();
            let m = date.getMinutes();
            let s = date.getSeconds();
            let monthDisplay = month.toString().padStart(2, '0');
            let dayDisplay = day.toString().padStart(2, '0');
            let hDisplay = h.toString().padStart(2, '0');
            let mDisplay = m.toString().padStart(2, '0');
            let sDisplay = s.toString().padStart(2, '0');
            return `${dayDisplay}/${monthDisplay}/${year} ${hDisplay}:${mDisplay}:${sDisplay}`;
        },
        formatDateTime(date) {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            const hour = date.getHours();
            const minute = date.getMinutes();
            const second = date.getSeconds();
            const monthDisplay = month.toString().padStart(2, '0');
            const dayDisplay = day.toString().padStart(2, '0');
            const hourDisplay = hour.toString().padStart(2, '0');
            const minuteDisplay = minute.toString().padStart(2, '0');
            const secondDisplay = second.toString().padStart(2, '0');
            return `${year}-${monthDisplay}-${dayDisplay}T${hourDisplay}:${minuteDisplay}:${secondDisplay}`;
        },
        isElapsedMinutesGreaterThen(startDate, maximumMinutes) {
            var endDate = new Date();
            return this.isMinutesBetweenDatesGreaterThen(startDate, endDate, maximumMinutes);
        },
        isMinutesBetweenDatesGreaterThen(startDate, endDate, maximumMinutes) {
            let elapsedMinutesSinceLastInteraction = this.differenceInMinutes(
                startDate,
                endDate
            );
            return elapsedMinutesSinceLastInteraction > maximumMinutes;
        },
        secondsToHHmm(d) {
            if (!d) return "00:00";
            d = Number(d);
            var h = Math.floor(d / 3600);
            var m = Math.floor((d % 3600) / 60);
            var s = Math.ceil(d % 3600 % 60);
            if (s > 30) m++;
            var hDisplay = h.toString().padStart(2, '0') + ":";
            var mDisplay = m.toString().padStart(2, '0');
            return hDisplay + mDisplay;
        },
        secondsToHHHmm(d) {
            if (!d) return "000:00";
            d = Number(d);
            var h = Math.floor(d / 3600);
            var m = Math.ceil((d % 3600) / 60);
            // var s = Math.ceil(d % 3600 % 60);
            // if (s > 1) m++;
            var hDisplay = h.toString().padStart(3, '0') + ":";
            var mDisplay = m.toString().padStart(2, '0');
            return hDisplay + mDisplay;
        },
        secondsToHms(d) {
            d = Number(d);
            var h = Math.floor(d / 3600);
            var m = Math.floor(d % 3600 / 60);
            var s = Math.ceil(d % 3600 % 60);
            var hDisplay = h.toString().padStart(2, '0') + ":";
            var mDisplay = m.toString().padStart(2, '0') + ":";
            var sDisplay = s.toString().padStart(2, '0');
            return hDisplay + mDisplay + sDisplay;
        },
        secondsToHmsFull(d) {
            d = Number(d);
            var h = Math.floor(d / 3600);
            var m = Math.floor(d % 3600 / 60);
            var s = Math.floor(d % 3600 % 60);
            var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
            var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
            var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
            return hDisplay + mDisplay + sDisplay;
        },
        timeToSeconds(time) {
            if (!time) return 0;
            if (time == "0") return 0;
            let timeSplited = time.toString().split(":");
            let hours = parseInt(timeSplited[0]);
            let minutes = parseInt(timeSplited[1]);
            let totalSeconds = (hours * 60 * 60) + (minutes * 60)
            return totalSeconds;
        },
    },
};
